module.exports = __webpack_public_path__ + "static/img/3.12ec4c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/sp/3.png
// module id = aZ/a
// module chunks = 0